import { Navigate, type RouteObject } from 'react-router';
import TransactionsLayout from '../layouts/TransactionsLayout';
import { GuestTransactionsPage } from '../pages/GuestTransactionsPage';
import RequirePermissionRoute from '@/components/permissions/RequirePermissionRoute';
import { Permission } from '@/modules/users/submodules/roles/api/permissions.contracts';

export const GUEST_TRANSACTION_ROUTES: RouteObject[] = [
  {
    path: 'guest-transactions',
    element: <TransactionsLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="overview" replace />,
      },
      {
        path: 'overview',
        element: (
          <RequirePermissionRoute requiredPermission={Permission.TRANSACTIONS_VIEW}>
            <GuestTransactionsPage />
          </RequirePermissionRoute>
        ),
      },
      {
        path: 'overview/:transactionId',
        element: (
          <RequirePermissionRoute requiredPermission={Permission.TRANSACTIONS_VIEW}>
            <GuestTransactionsPage />
          </RequirePermissionRoute>
        ),
      },
    ],
  },
];
